import { Button, type ButtonProps } from "@/components/ui/buttons/Button";

type Props = Omit<ButtonProps, "startIcon" | "endIcon">;

const IconButton = (props: Props) => {
    const { children, ...otherProps } = props;

    return <Button {...otherProps} startIcon={children} />;
};

export { IconButton };
export type { Props as IconButtonProps };
